import { combineReducers } from 'redux';

import UserReducer from './services/user/reducer';

const rootReducer = combineReducers({
    user: UserReducer,
});

export default rootReducer;